import { QUERY_PARAM_SORT, QUERY_PARAM_PAGE } from './filter-keys';

export default [
    QUERY_PARAM_SORT,
    QUERY_PARAM_PAGE
];



// WEBPACK FOOTER //
// ./src/components/filtered-listing/constants/querystring-whitelist.js